module.exports = __webpack_public_path__ + "static/img/sx4.e6884e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/sx/sx4.png
// module id = 9Sr5
// module chunks = 0